/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nCurrencyTwo.vue?vue&type=template&id=2761d1b7&scoped=true"
import script from "./nCurrencyTwo.vue?vue&type=script&lang=js"
export * from "./nCurrencyTwo.vue?vue&type=script&lang=js"
import style0 from "./nCurrencyTwo.vue?vue&type=style&index=0&id=2761d1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761d1b7",
  null
  
)

export default component.exports